import { TbBrandCpp } from "react-icons/tb";
import { SiPlatformio } from "react-icons/si";
import { SiArduino } from "react-icons/si";
import { SiKicad } from "react-icons/si";
import { SiEasyeda } from "react-icons/si";
import { SiPython } from "react-icons/si";
import { SiAnaconda } from "react-icons/si";
import { SiC } from "react-icons/si";
import { SiGit } from "react-icons/si";
import { SiRaspberrypi } from "react-icons/si";
import { SiAutodesk } from "react-icons/si";



const skills = {
    data: [
        {
            name: "c++",
            icon: <TbBrandCpp/>,
            color: "#00599C"
        },
        {
            name: "C",
            icon:  <SiC />,
            color: "#A8B9CC"
        },
        {
            name: "Python",
            icon:  <SiPython />,
            color: "#3776AB"
        },
        {
            name: "platform.io",
            icon: <SiPlatformio/>,
            color: "#F5822A"
        },
        {
            name: "Arduino IDE",
            icon: <SiArduino/>,
            color: "#00878F"
        },
        {
            name: "KiCAD",
            icon:  <SiKicad />,
            color: "#314CB0"
        },
        {
            name: "EasyEDA",
            icon:  <SiEasyeda/>,
            color: "#1765F6"
        },
        {
            name: "Anaconda",
            icon:  <SiAnaconda />,
            color: "#44A833"
        },
        {
            name: "Git",
            icon:  <SiGit />,
            color: "#F05032"
        },
        {
            name: "Pi Pico",
            icon:  <SiRaspberrypi />,
            color: "#A22846"
        },
        {
            name: "Autodesk Fusion360",
            icon:  <SiAutodesk  />,
            color: "#000000"
        },
    ]
        

}

export {skills}